import { render, staticRenderFns } from "./North.vue?vue&type=template&id=79282f4a"
import script from "./North.vue?vue&type=script&lang=js"
export * from "./North.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports